module.exports = __webpack_public_path__ + "static/media/elogo1.3de364a2.png";